// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".estimates-table-row__input[data-v-377f6105]{width:4em}", ""]);
// Exports
module.exports = exports;
